import type { ReactNode } from 'react';
import { Card, CardContent, Box, Typography } from '@mui/material';

/**
 * 统计卡片组件的属性
 */
export interface StatCardProps {
  /** 统计项标题 */
  title: string;
  /** 统计数值 */
  value: number;
  /** 图标 */
  icon: ReactNode;
  /** 主题颜色 */
  color: 'primary' | 'success' | 'info' | 'warning';
}

/**
 * 统计卡片组件
 *
 * 用于在 Dashboard 中显示各项统计数据。
 *
 * @example
 * <StatCard
 *   title="总授权数"
 *   value={100}
 *   icon={<KeyIcon />}
 *   color="primary"
 * />
 */
export function StatCard({ title, value, icon, color }: StatCardProps) {
  return (
    <Card>
      <CardContent>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Box>
            <Typography variant="body2" color="text.secondary" gutterBottom>
              {title}
            </Typography>
            <Typography variant="h3" component="div">
              {value}
            </Typography>
          </Box>
          <Box
            sx={{
              p: 2,
              borderRadius: 2,
              bgcolor: `${color}.main`,
              color: 'white',
            }}
          >
            {icon}
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
}
